"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOneTimePassword = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
let UserOneTimePassword = class UserOneTimePassword {
    _id = (0, uuid_1.v4)();
    userId;
    passwordHash;
    expiresAt;
    constructor(init) {
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.UserOneTimePassword = UserOneTimePassword;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4", { always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserOneTimePassword.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    (0, class_validator_1.IsUUID)("4", { always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserOneTimePassword.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserOneTimePassword.prototype, "passwordHash", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], UserOneTimePassword.prototype, "expiresAt", void 0);
exports.UserOneTimePassword = UserOneTimePassword = __decorate([
    (0, typeorm_1.Entity)("userOneTimePasswords"),
    (0, type_graphql_1.ObjectType)("UserOneTimePassword"),
    __metadata("design:paramtypes", [Object])
], UserOneTimePassword);
//# sourceMappingURL=UserOneTimePassword.js.map